import { Injectable } from '@angular/core';
import { ResponseCommonSI } from '@interfaces/services/common.interfaces';
import { firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { BASE_URL, ENDPOINTS } from '@core/config/constants';
import {
  RegisterSI,
  RolesSI,
  UpdateUserSI,
  UsersSI,
} from '@views/interfaces/services/users.interface';
import { SelectInterface } from '@avla/ui-design/commons';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  constructor(private http: HttpClient) {}

  async getUsers(): Promise<UsersSI[]> {
    const result = await firstValueFrom<ResponseCommonSI<UsersSI[]>>(
      this.http.get(`${BASE_URL}${ENDPOINTS.USERS}`)
    );
    return result.payload;
  }

  async getRoles(): Promise<RolesSI[]> {
    const result = await firstValueFrom<ResponseCommonSI<RolesSI[]>>(
      this.http.get(`${BASE_URL}${ENDPOINTS.ROLES}`)
    );
    return result.payload;
  }

  async register(body: RegisterSI): Promise<void> {
    await firstValueFrom<ResponseCommonSI<void>>(
      this.http.post(`${BASE_URL}${ENDPOINTS.USERS}`, body)
    );
  }

  async update(id: string, body: UpdateUserSI): Promise<void> {
    await firstValueFrom<ResponseCommonSI<void>>(
      this.http.put(`${BASE_URL}${ENDPOINTS.USERS}/${id}`, body)
    );
  }

  async delete(id: string): Promise<void> {
    await firstValueFrom<ResponseCommonSI<void>>(
      this.http.delete(`${BASE_URL}${ENDPOINTS.USERS}/${id}`)
    );
  }

  public async updateUserHelp(help: boolean): Promise<void> {
    await firstValueFrom<ResponseCommonSI<void>>(
      this.http.put(`${BASE_URL}${ENDPOINTS.USER_HELP}`, {help})
    );
  }

}
